let notificationFocusTarget: HTMLElement | null = null

const userInteractedToasts = new Set<number>()

export const useNotificationToastFocus = () => {
  const setNotificationFocusTarget = (element: HTMLElement | null) => {
    notificationFocusTarget = element
  }

  const getNotificationFocusTarget = () => notificationFocusTarget

  const clearNotificationFocusTarget = () => {
    notificationFocusTarget = null
  }

  const markToastUserInteracted = (id: number) => {
    userInteractedToasts.add(id)
  }

  const isToastUserInteracted = (id: number) => {
    return userInteractedToasts.has(id)
  }

  const clearToastUserInteraction = (id: number) => {
    userInteractedToasts.delete(id)
  }

  return {
    setNotificationFocusTarget,
    getNotificationFocusTarget,
    clearNotificationFocusTarget,
    markToastUserInteracted,
    isToastUserInteracted,
    clearToastUserInteraction,
  }
}
